module.exports = __webpack_public_path__ + "static/AviaryAttorney1-c5f093f5ed97d5f8905d36683cefd16c.png";